import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Design-system base styles MUST load before component CSS so that
// component-level overrides win the cascade without !important.
import './App.css';
import Navbar      from './components/Navbar';
import Footer      from './components/Footer';
import AIChatbot   from './components/AIChatbot';
import ScrollToTop from './components/ScrollToTop';
import Home          from './pages/Home';
import Products      from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact       from './pages/Contact';
import NotFound      from './pages/NotFound';
import ComingSoon    from './pages/ComingSoon';

// Temporary site-wide gate. Set REACT_APP_COMING_SOON=true in env/.env or
// env/.env.production to show only the ComingSoon page for every route —
// flip it back to unset/false to restore the real site. No other code
// changes needed either way.
const COMING_SOON = process.env.REACT_APP_COMING_SOON === 'true';

const App: React.FC = () => {
  if (COMING_SOON) return <ComingSoon />;

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="app">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/"            element={<Home />} />
            <Route path="/products"    element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/contact"     element={<Contact />} />
            <Route path="*"            element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <AIChatbot />
      </div>
    </BrowserRouter>
  );
};

export default App;
